<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ organization.name }} - {{ $t("COMMON.ROLES") }}
      </span>
    </div>

    <role-list-table :filterOrganization="organization.id" />
  </div>
</template>

<script>
import RoleListTable from "../../RoleManagement/partials/RoleListTable.vue";

export default {
  name: "organization-view-roles",

  components: { RoleListTable },

  props: ["organization"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    organization(organization) {},
  },
};
</script>
